import {
  KioskConnectivityStatusTooltip,
  KioskConnectivityStatusTooltipProps
} from '../kiosk-connectivity-status-tooltip/kiosk-connectivity-status-tooltip.component';
import {
  KioskConnectivityStatusIconColor,
  useKioskConnectivityStatusIconStyles
} from './kiosk-connectivity-status-icon.styles';

export interface KioskConnectivityStatusIconProps extends KioskConnectivityStatusTooltipProps {
  color: KioskConnectivityStatusIconColor;
  pulse: boolean;
}

export function KioskConnectivityStatusIcon({ color, pulse, ...tooltipProps }: KioskConnectivityStatusIconProps) {
  const classes = useKioskConnectivityStatusIconStyles({ color, pulse });
  return (
    <KioskConnectivityStatusTooltip {...tooltipProps}>
      <div className={classes.icon}></div>
    </KioskConnectivityStatusTooltip>
  );
}
